import type { ReactNode } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router';
import { useAuth } from '@/context/AuthContext';
import { safeReturn } from '@/lib/signIn';

// AuthRedirects - the two ends of a sign-in: an anonymous visit remembers
// where it was going, and a signed-in one goes there.

/** Sends an anonymous visit to the sign-in page, carrying where it was going. */
export function LoginRedirect() {
  const loc = useLocation();
  const target = loc.pathname + loc.search;
  const to = target === '/' ? '/login' : `/login?return=${encodeURIComponent(target)}`;
  return <Navigate to={to} replace />;
}

/**
 * Renders a sign-in page to an anonymous visit, and sends a signed-in one to
 * the page's `return`. A password sign-in lands here too: it sets the user, and
 * this sends them on.
 */
export function SignedInRedirect({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const [params] = useSearchParams();
  if (user) return <Navigate to={safeReturn(params.get('return'))} replace />;
  return <>{children}</>;
}
